import React from 'react';
import HomePage from './components/HomePage';


const App = () => {
    return (
        <div>
            <HomePage />
        </div>
    );

}


export default App;